/* KP Elite homepage sections. Vanilla JS, no dependencies. Re-inits in the theme editor. */
(function () {
  if (window.KPElite) return;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var isMob = function () { return window.matchMedia('(max-width: 749px)').matches; };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var once = function (el, k) { if (el['_kp' + k]) return false; el['_kp' + k] = 1; return true; };

  function headerVar() {
    var h = document.querySelector('.header-wrapper') || document.querySelector('.section-header');
    if (h) document.documentElement.style.setProperty('--kp-header-h', Math.round(h.getBoundingClientRect().height) + 'px');
  }

  function rotate(el) {
    if (!once(el, 'rot')) return;
    var w = [];
    try { w = JSON.parse(el.dataset.words || '[]'); } catch (e) {}
    w = w.map(function (s) { return String(s).trim(); }).filter(Boolean);
    if (w.length < 2 || RM.matches) return;
    var i = 0;
    setInterval(function () {
      el.classList.add('is-out');
      setTimeout(function () { i = (i + 1) % w.length; el.textContent = w[i]; el.classList.remove('is-out'); }, 250);
    }, 2400);
  }

  function heroVideo(v) {
    if (!once(v, 'hv') || RM.matches) return;
    var src = isMob() ? v.dataset.srcMobile : v.dataset.srcDesktop;
    if (!src) src = v.dataset.srcDesktop || v.dataset.srcMobile;
    if (!src) return;
    v.src = src;
    v.addEventListener('playing', function () { v.classList.add('is-ready'); }, { once: true });
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }

  function tabs(root) {
    if (!once(root, 'tabs')) return;
    var btns = $$('[role="tab"]', root);
    var select = function (b, focus) {
      btns.forEach(function (x) {
        var on = x === b;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) { p.hidden = !on; if (on) { var t = p.querySelector('.kp-track'); if (t) t.scrollLeft = 0; } }
      });
      if (focus) b.focus();
    };
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { if (b.getAttribute('aria-selected') !== 'true') select(b); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          select(btns[(i + (e.key === 'ArrowRight' ? 1 : -1) + btns.length) % btns.length], true);
        }
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) {
          $$('.kp-panel img[loading="lazy"]', root).forEach(function (img) { img.loading = 'eager'; });
          io.disconnect();
        }
      }, { rootMargin: '800px 0px' });
      io.observe(root);
    }
  }

  function pros(root) {
    if (!once(root, 'pros')) return;
    var track = root.querySelector('[data-kp-track]');
    var orig = Array.prototype.slice.call(track.children);
    var n = orig.length; if (n < 2) return;
    var mk = function () {
      return orig.map(function (c) {
        var k = c.cloneNode(true);
        k.setAttribute('aria-hidden', 'true'); k.tabIndex = -1;
        $$('a,button,[tabindex]', k).forEach(function (x) { x.tabIndex = -1; });
        return k;
      });
    };
    mk().reverse().forEach(function (k) { track.insertBefore(k, track.firstChild); });
    mk().forEach(function (k) { track.appendChild(k); });
    var dots = $$('[data-kp-dot]', root.parentNode);
    var i = n, busy = false;
    var step = function () { var c = track.children; return c[1].offsetLeft - c[0].offsetLeft; };
    var left = function () { var vw = root.clientWidth; return Math.max(16, (vw - Math.min(vw, 1200)) / 2 + 32); };
    var set = function (anim, dx) {
      track.style.transition = anim && !RM.matches ? 'transform .45s cubic-bezier(.2,.7,.2,1)' : 'none';
      track.style.transform = 'translate3d(' + (left() - i * step() + (dx || 0)) + 'px,0,0)';
    };
    var dot = function () { var k = ((i % n) + n) % n; dots.forEach(function (d, j) { d.classList.toggle('is-on', j === k); }); };
    var go = function (d) {
      if (busy) return; busy = true; i += d; dot(); set(true);
      setTimeout(function () { if (i < n) i += n; else if (i >= 2 * n) i -= n; set(false); busy = false; }, RM.matches ? 20 : 470);
    };
    set(false); dot();
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth === lastW) return; lastW = window.innerWidth; set(false); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { if (busy) return; var cur = ((i % n) + n) % n; if (j !== cur) go(j - cur); }); });
    var x0 = null, y0 = 0, dx = 0, horiz = null, pid = null;
    track.addEventListener('pointerdown', function (e) { if (busy) return; x0 = e.clientX; y0 = e.clientY; dx = 0; horiz = null; pid = e.pointerId; });
    track.addEventListener('pointermove', function (e) {
      if (x0 === null) return;
      var mx = e.clientX - x0, my = e.clientY - y0;
      if (horiz === null && (Math.abs(mx) > 6 || Math.abs(my) > 6)) { horiz = Math.abs(mx) > Math.abs(my); if (horiz) try { track.setPointerCapture(pid); } catch (er) {} }
      if (!horiz) return;
      var s = step(); dx = Math.max(-s, Math.min(s, mx)); set(false, dx);
    });
    var end = function () {
      if (x0 === null) return; x0 = null;
      if (!horiz) return;
      var t = Math.abs(dx) > 40 ? (dx < 0 ? 1 : -1) : 0;
      if (t) go(t); else set(true);
    };
    track.addEventListener('pointerup', end); track.addEventListener('pointercancel', end);
    track.addEventListener('click', function (e) { if (Math.abs(dx) > 6) { e.preventDefault(); e.stopPropagation(); dx = 0; } }, true);
    root.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault(); if (Math.abs(e.deltaX) > 8) go(e.deltaX > 0 ? 1 : -1);
    }, { passive: false });
    root.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(1); if (e.key === 'ArrowLeft') go(-1); });
  }

  function story(root) {
    if (!once(root, 'story')) return;
    var words = $$('[data-kp-word]', root), feats = $$('[data-kp-feat]', root), scr = $$('[data-kp-screen]', root);
    var ring = root.querySelector('[data-kp-ring]');
    var steps = Math.max(1, words.length), C = 2 * Math.PI * 226, cur = -1, raf = 0;
    if (ring) { ring.style.strokeDasharray = C; ring.style.strokeDashoffset = C; }
    var upd = function () {
      raf = 0;
      var r = root.getBoundingClientRect(), tot = r.height - window.innerHeight;
      var p = Math.min(1, Math.max(0, -r.top / Math.max(1, tot)));
      var a = Math.min(steps - 1, Math.floor(p * steps * 0.9999));
      if (ring) ring.style.strokeDashoffset = C * (1 - p);
      if (a !== cur) {
        cur = a;
        words.forEach(function (w, k) { w.classList.toggle('is-on', k <= a); });
        feats.forEach(function (f, k) { f.classList.toggle('is-on', k === a); });
        scr.forEach(function (s, k) { s.classList.toggle('is-on', k === a); });
      }
    };
    var q = function () { if (!raf) raf = requestAnimationFrame(upd); };
    window.addEventListener('scroll', q, { passive: true });
    window.addEventListener('resize', q);
    upd();
  }

  function vids(root) {
    if (!once(root, 'vids')) return;
    var tiles = $$('[data-kp-vtile]', root);
    tiles.forEach(function (t) {
      var v = t.querySelector('video'), b = t.querySelector('[data-kp-vbtn]');
      if (!v || !b) return;
      var load = function () { if (!v.getAttribute('src') && v.dataset.src) { v.src = v.dataset.src; } };
      b.addEventListener('click', function () {
        load();
        if (v.paused) {
          $$('[data-kp-vtile] video').forEach(function (o) { if (o !== v) o.pause(); });
          if (v.readyState < 3) t.classList.add('is-loading');
          var p = v.play(); if (p && p.catch) p.catch(function () { t.classList.remove('is-loading'); });
        } else v.pause();
      });
      v.addEventListener('playing', function () { t.classList.add('is-playing'); t.classList.remove('is-loading'); b.setAttribute('aria-label', 'Pause video'); });
      var stop = function () { t.classList.remove('is-playing', 'is-loading'); b.setAttribute('aria-label', 'Play video'); };
      v.addEventListener('pause', stop); v.addEventListener('ended', stop);
      v.addEventListener('waiting', function () { if (!v.paused) t.classList.add('is-loading'); });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) {
          tiles.forEach(function (t) { var v = t.querySelector('video'); if (v && v.dataset.src && !v.getAttribute('src')) { v.preload = 'metadata'; v.src = v.dataset.src; } });
          io.disconnect();
        }
      }, { rootMargin: '600px 0px' });
      io.observe(root);
    }
  }

  function loopVideo(v) {
    if (!once(v, 'loop') || RM.matches || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { if (!v.getAttribute('src')) v.src = v.dataset.src; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { rootMargin: '200px 0px' }).observe(v);
  }

  function gallery(root) {
    if (!once(root, 'gal')) return;
    var imgs = $('.kp-gallery__img', root), th = $$('[data-kp-thumb]', root);
    if (!th.length) return;
    root.setAttribute('data-kp-ready', '');
    var show = function (k) {
      imgs.forEach(function (im, j) { im.classList.toggle('is-on', j === k); if (j === k) im.loading = 'eager'; });
      th.forEach(function (b, j) { b.setAttribute('aria-pressed', j === k ? 'true' : 'false'); });
    };
    show(0);
  }

  function variants(scope) {
    if (!once(scope, 'var')) return;
    scope.addEventListener('change', function (e) {
      var r = e.target; if (!r.matches || !r.matches('.kp-variant input')) return;
      var pr = scope.querySelector('[data-kp-price]'), cp = scope.querySelector('[data-kp-compare]'), sv = scope.querySelector('[data-kp-save]'), sw = scope.querySelector('[data-kp-save-wrap]');
      if (pr) pr.textContent = r.dataset.price;
      if (cp) { cp.textContent = r.dataset.compare; cp.hidden = !r.dataset.compare; }
      if (sv) sv.textContent = r.dataset.save;
      if (sw) sw.hidden = !r.dataset.save;
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kp-acc-btn]');
    if (b) {
      var it = b.closest('[data-kp-acc]'); var open = !it.classList.contains('is-open');
      it.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var m = e.target.closest && e.target.closest('[data-kp-more-btn]');
    if (m) {
      var w = m.closest('.kp-more'); var o = !w.classList.contains('is-open');
      w.classList.toggle('is-open', o); m.setAttribute('aria-expanded', o ? 'true' : 'false');
      var lbl = m.querySelector('span'); if (lbl) lbl.textContent = o ? m.dataset.less : m.dataset.more;
    }
  });


  function mdots(row) {
    if (!once(row, 'md')) return;
    var items = Array.prototype.slice.call(row.children);
    if (items.length < 2) return;
    var d = document.createElement('div'); d.className = 'kp-mdots'; d.setAttribute('aria-hidden', 'true');
    items.forEach(function (it, k) { var i = document.createElement('i'); i.addEventListener('click', function () { row.scrollTo({ left: it.offsetLeft - row.offsetLeft, behavior: 'smooth' }); }); d.appendChild(i); });
    row.parentNode.insertBefore(d, row.nextSibling);
    var dots = Array.prototype.slice.call(d.children);
    var upd = function () { var w = row.clientWidth || 1; var k = Math.round(row.scrollLeft / (items[1].offsetLeft - items[0].offsetLeft || w)); dots.forEach(function (x, n) { x.classList.toggle('is-on', n === Math.max(0, Math.min(items.length - 1, k))); }); };
    row.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    upd();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-kp-thumb]');
    if (!t) return;
    var g = t.closest('[data-kp-gallery]'); if (!g) return;
    var k = +t.getAttribute('data-kp-thumb');
    g.setAttribute('data-kp-ready', '');
    $$('.kp-gallery__img', g).forEach(function (im, n) { im.classList.toggle('is-on', n === k); if (n === k) im.loading = 'eager'; });
    $$('[data-kp-thumb]', g).forEach(function (b, n) { b.setAttribute('aria-pressed', n === k ? 'true' : 'false'); });
  });

  function init(scope) {
    scope = scope || document;
    headerVar();
    $$('[data-kp-rotate]', scope).forEach(function (el) { try { rotate(el); } catch (e) { console.warn('KP', 'rotate', e); } });
    $$('[data-kp-hero-video]', scope).forEach(function (el) { try { heroVideo(el); } catch (e) { console.warn('KP', 'heroVideo', e); } });
    $$('[data-kp-tabs]', scope).forEach(function (el) { try { tabs(el); } catch (e) { console.warn('KP', 'tabs', e); } });
    $$('[data-kp-pros]', scope).forEach(function (el) { try { pros(el); } catch (e) { console.warn('KP', 'pros', e); } });
    $$('[data-kp-story]', scope).forEach(function (el) { try { story(el); } catch (e) { console.warn('KP', 'story', e); } });
    $$('.kp-results', scope).forEach(function (el) { try { vids(el); } catch (e) { console.warn('KP', 'vids', e); } });
    $$('[data-kp-loop]', scope).forEach(function (el) { try { loopVideo(el); } catch (e) { console.warn('KP', 'loopVideo', e); } });
    $$('[data-kp-gallery]', scope).forEach(function (el) { try { gallery(el); } catch (e) { console.warn('KP', 'gallery', e); } });
    $$('.kp-vids, .kp-reviews__grid--swipe', scope).forEach(function (el) { try { mdots(el); } catch (e) {} });
    $$('[data-kp-variant-scope]', scope).forEach(function (el) { try { variants(el); } catch (e) { console.warn('KP', 'variants', e); } });
  }

  window.KPElite = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.addEventListener('resize', headerVar);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
